import React from "react";
import * as styles from "./Link.module.scss";
import classNames from "classnames";
import Icon from "@app/components/Icon";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";

const Link = ({ icon = "", iconSize = 16, label, href = "#", onClick, className, target = "_self" }) => {
	const linkClassName = classNames({
		[styles["link"]]: true,
		[styles["has-icon"]]: !!icon,
		[className]: !!className,
	});

	return (
		<RouterLink
			className={linkClassName}
			to={href}
			target={target}
			onClick={(event) => {
				if (onClick && typeof onClick === "function") {
					event.preventDefault();
					onClick();
				}
			}}
		>
			{icon && <Icon icon={icon} size={iconSize} />}
			<span>{label}</span>
		</RouterLink>
	);
};

Link.propTypes = {
	icon: PropTypes.string,
	iconSize: PropTypes.number,
	label: PropTypes.string.isRequired,
	target: PropTypes.string,
	href: PropTypes.string,
	onClick: PropTypes.func,
	className: PropTypes.string,
};

export default Link;
